import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Courses from "../views/Courses.vue";
import Parcours from "../views/Parcours.vue";
import NotFound from "../views/NotFound.vue";
import Inscriptions from "../views/Inscriptions.vue";
import Live from "../views/Live.vue";
import Live_Passages from "../views/Live_Passages.vue";
import Live_Podiums from "../views/Live_Podiums.vue";
import Live_Carte from "../views/Live_Carte.vue";
import Live_Webcams from "../views/Live_Webcams.vue";
import Live_Favoris from "../views/Live_Favoris.vue";
import PCCourse from "../views/PCCourse.vue";
import Fiche from "../views/Fiche.vue";
import Resultats from "../views/Resultats.vue";
import Admin from "../views/Admin.vue";
import Live_Carte_Urgence from "../views/Live_Carte_Urgence.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "NotFound",
    component: NotFound,
  },
  {
    path: "/:base/fiche/:id_coureur",
    name: "Fiche",
    component: Fiche,
  },
  {
    path: "/:base",
    name: "Home",
    component: Home,
    children: [
      {
        path: "courses",
        name: "Courses",
        component: Courses,
      },
      {
        path: "admin",
        name: "Admin",
        component: Admin,
      },
      {
        path: "parcours",
        name: "Parcours",
        component: Parcours,
      },
      {
        path: "inscriptions",
        name: "Inscriptions",
        component: Inscriptions,
      },
      {
        path: "live",
        name: "Live",
        component: Live,
      },
      {
        path: "live_passages",
        name: "Live_Passages",
        component: Live_Passages,
      },
      {
        path: "live_podiums",
        name: "Live_Podiums",
        component: Live_Podiums,
      },
      {
        path: "live_carte",
        name: "Live_Carte",
        component: Live_Carte,
      },
      {
        path: "live_webcams",
        name: "Live_Webcams",
        component: Live_Webcams,
      },
      {
        path: "live_favoris",
        name: "Live_Favoris",
        component: Live_Favoris,
      },
      {
        path: "live_carte_urgence",
        name: "CarteLocalisationUrgence",
        component: Live_Carte_Urgence,
      },
      /*       {
        path: "fiche",
        name: "Fiche",
        component: Fiche,
      }, */
      {
        path: "resultats",
        name: "Resultats",
        component: Resultats,
      },
      {
        path: "pc-course",
        name: "PCCourse",
        component: PCCourse,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
